/*###########################################################################
// Scroll to Section
//#########################################################################*/

import { scrollTo } from "../utilities/_scrollTo"

const scrollToSection = {
	config: {
		button: '.scroll-to'
	},

	elements: {},

	init() {
		const self = this

		self.scrollToSection()
	},

	scrollToSection() {
		const self = this

		const elements = document.querySelectorAll('[data-scroll-to]')

		elements.forEach(element => {
			element.addEventListener('click', function(e) {
				e.preventDefault()
				const self = this
				const targetId = self.getAttribute('data-scroll-to')

				const targetSection = document.getElementById(`${targetId}`)

				if (targetSection !== null) {
					const headerHeight = document.querySelector('.header').clientHeight
					scrollTo(targetSection, -headerHeight)
				} else {
					console.log('Scroll target not found: ' + targetId);
				}
			})
		})
	}
}

initComponent(() => {
	scrollToSection.init()
})

